import React, { Fragment, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ClientLogo } from 'components';
import { usePublicClient } from 'hooks';
import { getAppImage } from 'helpers';
import { APP_IMAGES } from 'app-constants';

const useStyles = makeStyles(theme => ({
  logo: {
    marginBottom: theme.spacing(1),
  },
}));

interface IProps {
  i18nKey: string;
}

const ClientSidebarHeader: FC<IProps> = ({ i18nKey }) => {
  const classes = useStyles();
  const client = usePublicClient();
  const { t } = useTranslation();

  return (
    <Fragment>
      <ClientLogo client={client} />
      <Typography variant="h4" color="textSecondary">
        {t(i18nKey)}
      </Typography>
      <div className={classes.logo}>
        <img {...getAppImage(APP_IMAGES.Logo)} />
      </div>
    </Fragment>
  );
};

export default ClientSidebarHeader;
